import { render, staticRenderFns } from "./IdCargaCCEE.vue?vue&type=template&id=20998a42&scoped=true&"
import script from "./IdCargaCCEE.vue?vue&type=script&lang=js&"
export * from "./IdCargaCCEE.vue?vue&type=script&lang=js&"
import style0 from "./IdCargaCCEE.vue?vue&type=style&index=0&id=20998a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20998a42",
  null
  
)

export default component.exports